import classes from "./NutritionPlanTab.module.css";
import NutritionBars from "./NutritionBars";
import CardWithBarChart from "./CardWithBarChart";
import PieChartWithSectors from "../common/PieChartWithSectors";
import useTheme from "../../../../common/hooks/useTheme";
import { useSelector } from "react-redux";
import { RootStatePlatform } from "../../store/platform-slice";
import React from "react";

const NutritionPlanTab = () => {
  const theme = useTheme();
  const reportData = useSelector(
    (state: RootStatePlatform) =>
      state.platform.dataPlatformServer.programming.nutritionPlan
  );

  const nonWorkoutAnalysisChartData = {
    title: reportData.nonWorkoutTitle,
    pieTitle: "Macronutrient breakdown",
    calorieIntakeValue:
      reportData.nonWorkoutAnalysisChartData.caloricIntakeValue,
    dailyActivityValue:
      reportData.nonWorkoutAnalysisChartData.dailyActivityValue,
    RMRValue: reportData.nonWorkoutAnalysisChartData.rmrValue,
    workoutValue: reportData.nonWorkoutAnalysisChartData.workoutValue,
    pieData: reportData.nonWorkoutAnalysisChartData.pieData.map(
      (slice, index: number) => {
        return {
          label: slice.label,
          value: slice.valueInGram,
          categoryType: index + 1,
        };
      }
    ),
  };

  const workoutAnalysisChartData = {
    title: reportData.workoutTitle,
    pieTitle: "Macronutrient breakdown",
    calorieIntakeValue: reportData.workoutAnalysisChartData.caloricIntakeValue,
    dailyActivityValue: reportData.workoutAnalysisChartData.dailyActivityValue,
    RMRValue: reportData.workoutAnalysisChartData.rmrValue,
    workoutValue: reportData.workoutAnalysisChartData.workoutValue,
    pieData: reportData.workoutAnalysisChartData.pieData.map(
      (slice, index: number) => {
        return {
          label: slice.label,
          value: slice.valueInGram,
          categoryType: index + 1,
        };
      }
    ),
  };

  return (
    <div className={classes.innerContainer}>
      <div
        style={{
          color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
          fontFamily: "var(--font-Medium)",
          fontSize: "20px",
          lineHeight: "28px",
          paddingBottom: "24px",
        }}
      >
        Nutrition Plan
      </div>
      <div className={classes.sectionOne}>
        <NutritionBars data={nonWorkoutAnalysisChartData} />
        <NutritionBars data={workoutAnalysisChartData} />
      </div>
      <div
        className={classes.box}
        style={{
          borderColor: theme.colors_ds.NEUTRAL_BORDER_WEAK,
          backgroundColor: theme.colors_ds.NEUTRAL_BG_MAIN,
        }}
      >
        <div
          className={classes.title}
          style={{ color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT }}
        >
          {reportData.nutritionBreakdownTitle}
        </div>
        <div
          className={classes.text}
          style={{ color: theme.colors_ds.NEUTRAL_TEXT_STRONG }}
        >
          {reportData.nutritionBreakdownText}
        </div>
      </div>
      <div className={classes.sectionTwo}>
        <div>
          <div
            className={classes.title}
            style={{ color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT }}
          >
            {reportData.microNutrientsTitle}
          </div>
          <div className={classes.cardContainer}>
            {reportData.microNutrients.map((el, index: number) => (
              <CardWithBarChart key={index} data={el} />
            ))}
          </div>
        </div>
        <div className={classes.chartsContainer}>
          <PieChartWithSectors
            chartData={reportData.proteinAnalysisChartData}
          />
          <PieChartWithSectors chartData={reportData.fatAnalysisChartData} />
          <PieChartWithSectors chartData={reportData.carbsAnalysisChartData} />
        </div>
      </div>
    </div>
  );
};

export default NutritionPlanTab;
